import InvalidRuts from "./InvalidRuts";

const enum ErrorValidations{
  Required = "Requerido",  
  Mask = "Formato incorrecto",
  RutFormat = "Formato Rut incorrecto",
  RutInvalid = "Rut invalido",
  EndDateGT = "Fecha fin menor a fecha inicio",
  InvalidDate = "Formato de fecha incorrecto"
};

const RequiredValidator = (value?: string) => {
  return !value && value !== "" ? ErrorValidations.Required : undefined;
} 

//const RequiredValidator1 = (Select?: number) => {
//  return !Select ? ErrorValidations.Required : undefined;
//}

const MaskValidator = (value?: string) => {
  const mask = RegExp('!/^(?=.*)(?=.*[A-Za-z]).*$/');
  return (value && !mask.test(value) ? ErrorValidations.Mask: undefined);
};  

const FormatRutValidator = (value?: string | undefined) => {
  const maskRut = RegExp("^[0-9]+-[0-9kK]{1}$");  
  return (value && !maskRut.test(value) ? ErrorValidations.RutFormat: undefined);
};

const RutValidator = (value?: string) => {
  let isInvalid = false;
  if (value && value.lastIndexOf("-") === value.length - 2 ){
    const dv = value.split("-").at(1)?.toUpperCase();
    const mantizaInvertida = value.split("-").at(0)?.split("").reverse().join("") ?? "";

    let suma = 0;    
    for(let i=0, j=2; i < mantizaInvertida.length; i++, ((j===7) ? j=2 : j++)){
      suma += (parseInt(mantizaInvertida.charAt(i)) * j); 
    }

    let n_dv = 11 - (suma % 11);    

    isInvalid = dv !== ((n_dv === 11) ? "0" : ((n_dv === 10) ? "K" : n_dv.toString()));

    if (!isInvalid){
      isInvalid = InvalidRuts.includes(value);    
    }
  }
  
  return (isInvalid ? ErrorValidations.RutInvalid: undefined);
};

export { ErrorValidations, RequiredValidator, MaskValidator, FormatRutValidator, RutValidator }